<template>
  <div id="seletor">
        <el-checkbox-group v-model="selectedMutable" @change="update">
          <div v-for="(element) in elements" :key="element.id">
            <div class="seletor-checkbox-line" />
            <el-checkbox :label="element.id">
              <template slot-scope>
                <span v-if="element.color" :style="statusColor(element.color)" class="status"></span>
                <span class="seletor-label-only">{{ element.name }}</span>
              </template>
            </el-checkbox>
          </div>
        </el-checkbox-group>
  </div>
</template>
<script>
export default {
  props: {
    model: {
      type: Array
    },
    elements: {
      type: Array
    },
    name: {
      type: String
    },
    selected: {
      type: [Array, Object],
      default: () => []
    }
  },
  watch: {
    selected (newValue) {
      this.selectedMutable = newValue
    }
  },
  data () {
    return {
      selectedMutable: []
    }
  },
  created () {
    this.selectedMutable = this.selected
  },
  methods: {
    update () {
      this.$emit('update:selected', this.selectedMutable)
    },
    statusColor (color) {
      return {
        'background-color': `${color} !important`
      }
    }
  }
}
</script>
